export default "__VITE_ASSET__Bqqs2ixk__"